import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";
import { useForm } from "vee-validate";
import { useErrors } from "@/utils/api-functions";

//@ts-ignore
import FormInput from "@/components/form/input.vue";
//@ts-ignore
import FormCheckbox from "@/components/form/checkbox.vue";
//@ts-ignore
import FormCombobox from "@/components/form/combobox.vue";
//@ts-ignore
import Submit from "@/components/form/submit.vue";
import * as Yup from "yup";
import { nl } from "yup-locales";
import { useApiStore } from "@/stores/api";
import { useAppStore } from "@/stores/app";


export default /*#__PURE__*/_defineComponent({
  props: {
    tags: { type: null, required: true, default: () => [] },
    mailchimpGroupId: { type: String, required: true },
    mailchimpIds: { type: Array, required: true, default: () => [] },
    title: { type: String, required: true },
    description: { type: String, required: true },
    url: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { tags: any, mailchimpGroupId: string, mailchimpIds: string[], title: string, description: string, url: string }

const appStore = useAppStore();
const apiErrors = useErrors();
const apiStore = useApiStore();



const success = ref(false);
const loading = ref(false);
const showUrl = ref(false);
const component = ref<HTMLDivElement>();

Yup.setLocale(nl);

const { handleSubmit, isSubmitting, values } = useForm({
    initialValues: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        href: window.location.href,
        pathname: window.location.pathname,
        tags: props.tags,
        mailchimp_group_id: props.mailchimpGroupId,
        mailchimp_ids: props.mailchimpIds,
    },
    validationSchema: Yup.object({
        first_name: Yup.string().required().label("Voornaam"),
        last_name: Yup.string().required().label("Achternaam"),
        email: Yup.string().email().required().label("Email"),
        phone: Yup.string()
            .matches(/(((\+|00)3[12][ ]?(?:\(0\)[ ]?)?)|0){1}(4(60|[789]\d)\/?(\s?\d{2}\.?){2}(\s?\d{2})|(\d\/?\s?\d{3}|\d{2}\/?\s?\d{2})(\.?\s?\d{2}){2})/, "Telefoonnummer is ongeldig")
            .required()
            .label("Telefoonnummer"),
        href: Yup.string().required(),
        pathname: Yup.string().required(),
        tags: Yup.string().label("Tags"),
        mailchimp_group_id: Yup.string().label("Mailchimp group ids"),
        mailchimp_ids: Yup.array().label("Mailchimp ids"),
    }),
});

const dynamicallyCreateAnchorAndNavigate = function (url: any) {
    let anchorElement = document.createElement("a");
    anchorElement.href = url;
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
};

const openInNewTab = function (url: any) {
    dynamicallyCreateAnchorAndNavigate(url);
};

const onSubmit = handleSubmit(async (values, { resetForm }) => {
    try {
        loading.value = true;
        showUrl.value = false;

        // @ts-ignore
        await apiStore.downloadBrochure(values);

        // @ts-ignore
        if (window.hasOwnProperty("dataLayer") && dataLayer) {
            // @ts-ignore
            dataLayer.push({
                event: "cf7submission",
                formId: "1912",
                response: [
                    { name: "first_name", value: values.first_name },
                    { name: "last_name", value: values.last_name },
                    { name: "email", value: values.email },
                    { name: "phone", value: values.phone },
                    { name: "href", value: window.location.href },
                    { name: "pathname", value: window.location.pathname },
                ],
            });
        }

        success.value = true;

        // download url
        showUrl.value = true;
        openInNewTab(props.url);

        setTimeout(resetForm, 500);
    } catch (error) {
        apiErrors.parse(error);
    } finally {
        loading.value = false;
    }
});

const __returned__ = { appStore, apiErrors, apiStore, props, success, loading, showUrl, component, handleSubmit, isSubmitting, values, dynamicallyCreateAnchorAndNavigate, openInNewTab, onSubmit, FormInput, Submit }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})